// extracted by mini-css-extract-plugin
export default {"title_container":"sectionTitle_title_container__-dQfG","title":"sectionTitle_title__kfdHU","solutions_container":"sectionTitle_solutions_container__Qhoqj"};